export const defaultNumberFormatOptions = {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
}

export const defaultKwhFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
}

export const defaultKwpFormatOptions = {
  minimumFractionDigits: 0,
  maximumFractionDigits: 3,
	multiplier: 1000 // show kWp in Wp, prevents need for extensive changes in Odoo and refactor of field names
}
